import { useLocation } from 'react-router'

import { UNTIL_CHANGESET_KEY_QUERY_PARAM } from '../system/paths'

export const useUntilChangesetKeyValue = () => {
  const { search } = useLocation()
  return new URLSearchParams(search).get(UNTIL_CHANGESET_KEY_QUERY_PARAM)
}
